import { useLocation } from "react-router-dom";
import "./Footer.css";
function Footer() {
  let location = useLocation();
  let path = location.pathname === "/";
 
  return (
    <div className={`${path ? "hideFooter" : "footer"}`}>
      <div className="footer-content footer-align">
        <div className="footer-text">
          <ul>
            <li className="heading">Cross Valley Homes</li>
            <li>Captivate and Inspire.</li>
          </ul>

          <ul>
            <li className="email">Info@crossvalleyhomes.com</li>
            <li className="contactus">
              <div className="tags-section">
                <a
                  href="https://www.instagram.com/crossvalleyhomes?igsh=NnVhbzJzOXVkcXp2"
                  className="social-icons"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="22"
                    height="22"
                    viewBox="0 0 50 50"
                    fill="rgba(77, 77, 77, .72);"
                  >
                    <path d="M 16 3 C 8.8545455 3 3 8.8545455 3 16 L 3 34 C 3 41.145455 8.8545455 47 16 47 L 34 47 C 41.145455 47 47 41.145455 47 34 L 47 16 C 47 8.8545455 41.145455 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.054545 5 45 9.9454545 45 16 L 45 34 C 45 40.054545 40.054545 45 34 45 L 16 45 C 9.9454545 45 5 40.054545 5 34 L 5 16 C 5 9.9454545 9.9454545 5 16 5 z M 37 11 C 35.9 11 35 11.9 35 13 C 35 14.1 35.9 15 37 15 C 38.1 15 39 14.1 39 13 C 39 11.9 38.1 11 37 11 z M 25 14 C 18.954545 14 14 18.954545 14 25 C 14 31.045455 18.954545 36 25 36 C 31.045455 36 36 31.045455 36 25 C 36 18.954545 31.045455 14 25 14 z M 25 16 C 29.954545 16 34 20.045455 34 25 C 34 29.954545 29.954545 34 25 34 C 20.045455 34 16 29.954545 16 25 C 16 20.045455 20.045455 16 25 16 z"></path>
                  </svg>
                </a>
              </div>
              Louisville, KY
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Footer;
